
import styled from 'styled-components';

import { headerVariables } from '../../components/Header/HeaderStyle';
import { breakpoints, colors, fontFamily } from '../../ui/variables';

export const UserProfileStyle = styled.div`
  background-color: ${colors.veryPaleBlue};
  min-height: 100vh;
  padding: ${headerVariables.main.height.iphone + 36}px 20px 36px;

  @media (min-width: ${breakpoints.ipadLandscape.width}px) {
    padding: ${headerVariables.main.height.iphone + 64}px 64px 64px;
  }

  .profile-shell {
    margin: 0 auto;
    max-width: 1180px;
    display: grid;
    gap: 24px;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      grid-template-columns: minmax(240px, 320px) minmax(0, 1fr);
      align-items: start;
      gap: 32px;
    }
  }

  .left-column,
  .right-column {
    background-color: ${colors.white};
    border: 1px solid ${colors.lightGrayishBlue};
    border-radius: 8px;
    padding: 24px;
  }

  .left-column {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .profile-avatar {
    align-items: center;
    background-color: ${colors.veryPaleBlue};
    border-radius: 50%;
    display: flex;
    height: 120px;
    justify-content: center;
    margin-bottom: 16px;
    overflow: hidden;
    width: 120px;

    img {
      display: block;
      height: 100%;
      object-fit: cover;
      width: 100%;
    }

    svg {
      fill: ${colors.softBlue};
      height: 56px;
      width: 56px;
    }
  }

  .profile-name {
    ${fontFamily.sourceSansPro.bold}
    color: ${colors.veryDarkGray};
    font-size: 22px;
    line-height: 28px;
    margin: 0 0 4px;
  }

  .upload-button {
    ${fontFamily.sourceSansPro.bold}
    background-color: ${colors.veryPaleBlue};
    border: 1px solid ${colors.softBlue};
    border-radius: 8px;
    color: ${colors.softBlue};
    cursor: pointer;
    font-size: 13px;
    line-height: 16px;
    margin: 0 0 12px;
    padding: 10px 14px;
    transition: opacity 200ms;

    &:hover {
      opacity: 0.85;
    }
  }

  .file-input {
    display: none;
  }

  .profile-type {
    ${fontFamily.sourceSansPro.regular}
    color: ${colors.darkGrayishBlue};
    font-size: 14px;
    line-height: 20px;
    margin: 0;
    word-break: break-word;
  }

  .form-title {
    ${fontFamily.sourceSansPro.bold}
    color: ${colors.veryDarkGray};
    font-size: 24px;
    line-height: 30px;
    margin: 0 0 20px;
  }

  .inline-fields {
    display: grid;
    gap: 12px;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 16px;
    }
  }

  .field-wrapper {
    margin-bottom: 16px;

    .input-label {
      ${fontFamily.sourceSansPro.bold}
      color: ${colors.darkGrayishBlue};
      display: block;
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 8px;
    }
  }

  .feedback-success,
  .feedback-error {
    ${fontFamily.sourceSansPro.regular}
    font-size: 14px;
    line-height: 20px;
    margin: 4px 0;
    text-align: left;
  }

  .feedback-success {
    color: ${colors.limeGreen};
  }

  .feedback-error {
    color: ${colors.softRed};
  }

  .button-wrapper {
    margin-top: 20px;
  }
`;
